(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/models/result.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/models/result.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
const productMapping = svs.numbergames.productMapping;
svs.numbergames.results.models.Result = svs.numbergames.core.NumbergamesModel.extend({
  defaults: {
    productId: '',
    productDrawId: undefined,
    drawNumber: undefined,
    addonDrawId: undefined,
    addonDrawNumber: undefined,
    numbers: undefined,
    numbersExtra: undefined,
    kungKenoNumber: undefined,
    payout: undefined,
    payouts: undefined,
    lotto1: undefined,
    lotto2: undefined,
    joker: undefined,
    currentNetSale: undefined,
    regCloseTime: '',
    totalPayout: undefined,
    totalWinners: undefined,
    topWin: undefined,
    winningCountries: undefined,
    winningCountry: undefined
  },
  async fetchAction(options) {
    const _this$attributes = this.attributes,
      productDrawId = _this$attributes.productDrawId,
      drawNumber = _this$attributes.drawNumber,
      addonDrawId = _this$attributes.addonDrawId,
      addonDrawNumber = _this$attributes.addonDrawNumber;
    try {
      var _resultResponse$respo, _resultResponse$respo2, _addonResultResponse$, _addonResultResponse$2;
      const requests = [];
      if (drawNumber) {
        requests.push(drawgamesApiCaller.getDrawProductDrawsResult({
          product: productDrawId,
          drawNumber
        }));
        if (productMapping.hasJoker(productDrawId) && addonDrawId && addonDrawNumber) {
          requests.push(drawgamesApiCaller.getDrawProductDrawsResult({
            product: addonDrawId,
            drawNumber: addonDrawNumber
          }));
        }
      } else {
        requests.push(drawgamesApiCaller.getDrawProductDrawsResultLatest({
          product: productMapping.getMigrationProductDrawId(productDrawId, {
            apiCaller: drawgamesApiCaller,
            apiPathFnName: 'getDrawProductDrawsResultLatest'
          })
        }));
      }
      const _await$Promise$all = await Promise.all(requests),
        _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
        resultResponse = _await$Promise$all2[0],
        addonResultResponse = _await$Promise$all2[1];
      options.success({
        result: (_resultResponse$respo = resultResponse === null || resultResponse === void 0 || (_resultResponse$respo2 = resultResponse.response) === null || _resultResponse$respo2 === void 0 ? void 0 : _resultResponse$respo2.result) !== null && _resultResponse$respo !== void 0 ? _resultResponse$respo : resultResponse === null || resultResponse === void 0 ? void 0 : resultResponse.result,
        addonResult: (_addonResultResponse$ = addonResultResponse === null || addonResultResponse === void 0 || (_addonResultResponse$2 = addonResultResponse.response) === null || _addonResultResponse$2 === void 0 ? void 0 : _addonResultResponse$2.result) !== null && _addonResultResponse$ !== void 0 ? _addonResultResponse$ : addonResultResponse === null || addonResultResponse === void 0 ? void 0 : addonResultResponse.result
      });
    } catch (error) {
      options.error(error);
    }
  },
  parse(attrs) {
    let result, addonResult, error;
    if (attrs.responses) {
      var _attrs$responses = _slicedToArray(attrs.responses, 2);
      var _attrs$responses$ = _attrs$responses[0];
      result = _attrs$responses$.result;
      error = _attrs$responses$.error;
      addonResult = _attrs$responses[1].result;
    } else {
      result = attrs.result;
      addonResult = attrs.addonResult;
    }
    if (error) {
      svs.numbergames.results.logger.error('Error parsing result:', error.message);
      return;
    }
    let payout;
    let payouts;
    let joker;
    let lotto1;
    let lotto2;
    let correctRow = {};
    const data = svs.numbergames.results_common.parsers.results.parseResult(result);
    if (data) {
      if (data.correctRow) {
        correctRow = data.correctRow;
      }
      if (data.payout) {
        payout = new svs.numbergames.results.models.PayoutTable(data.payout, {
          parse: true
        });
      }
      if (data.payouts) {
        payouts = new svs.numbergames.results.collections.PayoutTables(data.payouts, {
          parse: true
        });
      }
      if (data.lotto1 && data.lotto2) {
        lotto1 = new svs.numbergames.results.models.LottoPartResult(data.lotto1, {
          parse: true
        });
        lotto2 = new svs.numbergames.results.models.LottoPartResult(data.lotto2, {
          parse: true
        });
      }
    }
    if (addonResult) {
      joker = new svs.numbergames.results.models.Result({
        result: addonResult
      }, {
        parse: true
      });
    }
    return _objectSpread(_objectSpread({}, data), {}, {
      payout,
      payouts,
      joker,
      lotto1,
      lotto2
    }, correctRow);
  }
});

 })(window);